import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'ui/sonner'

import { Route } from '~/routes/auth/route'

export const useSearchParamsError = (title?: string) => {
  const { error } = Route.useSearch()
  const { t } = useTranslation()

  useEffect(() => {
    // todo: refactor. not sure if it works after migration to tanstack router
    if (!error) return

    setTimeout(() => toast.error(title || t('Wrong google account')), 0)
  }, [error, title, t])
}
